<main class="select-fan-page" *ngIf = "pageContent" >
		<h1 class="pageHeading remove-heading" *ngIf="!ibmflag"><strong> {{pageContent.heading}} </strong></h1>
		<h1 class="pageHeadingmdm" *ngIf="ibmflag"> {{pageContent.heading}} </h1>
		<div *ngIf="showError" id="alertMessage" class="alert valign-children-middle alertMsg">
			<div class="alert-error" role="img" aria-label="Alert.">
				<i class="icon-badgealert"></i>
			</div>
			<div>
				<span>{{pageContent.errorMessage}}</span>
			</div>
		</div>
	<div class="select-wrapper" *ngIf="!ibmflag">
		<div *ngIf="FANList.length === 0">
			<h2>{{pageContent.noFans}}</h2>
			<p>
				<a href="javascript:void(0)" (click)="backToCallingPage()" class="btn btn-link btn-block btn-cancel btnCancel"> {{pageContent.buttons.back}} </a>
			</p>
			</div>
		<div *ngIf="FANList.length > 0">
			<div *ngIf="!unclaim">
				<h2> {{pageContent.subhead}}</h2>
				<p> {{pageContent.fanCount}}</p>
				<p> {{pageContent.selectedFans}} </p>
			</div>
			<!-- <h2 *ngIf="unclaim"> {{prodcode}}</h2> -->
			<!-- <h2 *ngIf="unclaim"> {{ prodcode === 'Apple Business Manager' ? 'Apple Business' : prodcode }}</h2> -->
			<h2 *ngIf="unclaim"> {{
				prodcode === 'Apple Business Manager'
				? 'Apple Business'
				: (prodcode === 'Samsung Knox Mobile'
					? 'Samsung Knox Mobile Enrollment'
					: prodcode)
			}} </h2>
			<app-customgrid [gridOptions]="gridOptions" (onDataChange)="onRowClick($event)"></app-customgrid>
			<p class="fans"><strong>{{pageContent.selectedFans}} </strong></p>
			<p>
				<label class="checkbox" *ngIf="unclaim">
				<input type="checkbox" (change)="unclaimCheck = !unclaimCheck">
				<i class="skin"></i>
				<span>{{pageContent.checkboxText}} </span>
				  </label>
			</p>
			<div  *ngIf="abmflag" class="tooltip-input inline-labels">
				<i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp"
				(mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)" aria-label="Help"></i>
				<div role="tooltip" class="helper-text" id="inputhelp">
					{{pageContent.toolTipText}}</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-md-12 text-right buttons-section">
					<button [disabled]="SelectedFANList.length == 0" (click)="continueToNext()" aria-label="Continue." class="btn btn-secondary pull-right"> {{pageContent.buttons.submit}} </button>
					<a href="javascript:void(0)" (click)="backToCallingPage()" class="btn btn-link btn-block btn-cancel btnCancel"> {{pageContent.buttons.back}} </a>
				</div>
			</div>
		</div>
	</div>
	<div class="select-wrappermdm" *ngIf="ibmflag">
		<div *ngIf="gridOptions && FANList.length === 0">
			<h2>{{pageContent.noFans}}</h2>
		</div>
		<div *ngIf="FANList.length > 0">
			<h2> {{pageContent.subhead}}</h2>
			<p> {{pageContent.fanCount}}</p>
			<p> {{pageContent.selectedFans}} </p>
			<app-customgrid [gridOptions]="gridOptions" (onDataChange)="onRowClick($event)"></app-customgrid>
			<p> {{pageContent.selectedFans}}</p>
			<div class="row">
				<div class="col-sm-12 col-md-12 text-right buttons-section">
					<button [disabled]="SelectedFANList.length == 0" (click)="continueToNextmdm()" aria-label="Continue." class="btn btn-secondary pull-right"> {{pageContent.buttons.submit}} </button>
					<a href="javascript:void(0)" (click)="backToCallingPagemdm()" class="btn btn-link btn-block btn-cancel btnCancel"> {{pageContent.buttons.cancel}} </a>
				</div>
			</div>
		</div>
	</div>
</main>
